import React, { memo } from "react";

const CuTooltip = memo((props) => {
  const { position = "top", text, children } = props;

  // Tooltip position classes
  const positionClasses = {
    top: "bottom-full left-1/2 -translate-x-1/2 mb-2",
    bottom: "top-full left-1/2 -translate-x-1/2 mt-2",
    left: "right-full top-1/2 -translate-y-1/2 mr-2",
    right: "left-full top-1/2 -translate-y-1/2 ml-2",
  };

  // Arrow position classes
  const arrowClasses = {
    top: "before:top-full before:left-1/2 before:-translate-x-1/2 before:border-t-black",
    bottom:
      "before:bottom-full before:left-1/2 before:-translate-x-1/2 before:border-b-black",
    left: "before:left-full before:top-1/2 before:-translate-y-1/2 before:border-l-black",
    right:
      "before:right-full before:top-1/2 before:-translate-y-1/2 before:border-r-black",
  };

  return (
    <span className="group relative z-[999]">
      <span
        className={`pointer-events-none absolute whitespace-nowrap rounded bg-black px-2 py-1 text-white opacity-0 transition before:absolute before:border-4 before:border-transparent group-hover:opacity-100 ${positionClasses[position]} ${arrowClasses[position]}`}
      >
        {text}
      </span>
      {children}
    </span>
  );
});

CuTooltip.displayName = "Tooltip";

export default CuTooltip;
